var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWarning = function SvgIconWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FCCC50",
    d: "M2.503 17.431a.94.94 0 0 1-.813-1.407L9.188 3.038a.938.938 0 0 1 1.624 0l7.498 12.986a.94.94 0 0 1-.812 1.407z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCCC50",
    d: "M10 2.881a.61.61 0 0 1 .542.313l7.498 12.987a.625.625 0 0 1-.542.938H2.502a.625.625 0 0 1-.541-.938L9.458 3.194A.62.62 0 0 1 10 2.881m0-.625a1.24 1.24 0 0 0-1.083.626L1.42 15.868a1.25 1.25 0 0 0 1.082 1.876h14.996a1.25 1.25 0 0 0 1.083-1.876L11.083 2.882A1.24 1.24 0 0 0 10 2.256"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M10 15.31a.625.625 0 1 0 0-1.25.625.625 0 0 0 0 1.25M10.625 7.186a.625.625 0 1 0-1.25 0v5a.625.625 0 1 0 1.25 0z"
  })));
};
export default SvgIconWarning;